export default "# ~~Harberger~~ Hamburger Taxation";